import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useTransactionStore } from '@/store/useTransactionStore'
import { BaseView, BaseText } from '@/components/base'
import { CheckoutFlow } from '../CheckoutFlow'

interface CheckoutSectionProps {
  paymentSessionToken: string
  paymentSessionSecret: string | null
  paymentSession: any
  transactionId: string | null
}

export function CheckoutSection({
  paymentSessionToken,
  paymentSessionSecret,
  paymentSession,
  transactionId,
}: CheckoutSectionProps) {
  const { t } = useTranslation()
  const clearLastTransactionData = useTransactionStore(
    (state) => state.clearLastTransactionData,
  )

  // Memoize callbacks to avoid recreating CheckoutFlow
  const handleSuccess = useCallback(() => {
    clearLastTransactionData()
  }, [clearLastTransactionData])

  const handleError = useCallback((error: string) => {
    console.error('[CheckoutSection] Checkout error:', error)
  }, [])

  // If no secret, show error
  if (!paymentSessionSecret) {
    return (
      <BaseView flex={1} p={16}>
        <BaseView mb={16}>
          <BaseText fontSize={18} fontFamily="semibold" color="label.default">
            {t('common:checkoutPayment', 'Checkout Payment')}
          </BaseText>
        </BaseView>
        <BaseView mb={24}>
          <BaseText fontSize={14} color="label.error">
            {t(
              'common:missingPaymentSecret',
              'Payment session secret is missing. Please try again.',
            )}
          </BaseText>
        </BaseView>
      </BaseView>
    )
  }

  return (
    <CheckoutFlow
      paymentSessionToken={paymentSessionToken}
      paymentSessionSecret={paymentSessionSecret}
      orderId={paymentSession?.order_id || ''}
      paymentSession={paymentSession}
      transactionId={transactionId || ''}
      onSuccess={handleSuccess}
      onError={handleError}
    />
  )
}
